"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCategorisedAddOns = getCategorisedAddOns;
exports.getFilteredBalances = getFilteredBalances;
exports.getLatestInvoiceId = getLatestInvoiceId;
exports.useData = useData;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireDefault(require("react"));
var _xbytes = _interopRequireDefault(require("xbytes"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function getFilteredBalances(balances) {
  var results = {};
  var data = balances.find(function (balance) {
    return balance.balanceReferenceId === "DATA";
  });
  var text = balances.find(function (balance) {
    return balance.balanceReferenceId === "SMS";
  });
  var voice = balances.find(function (balance) {
    return balance.balanceReferenceId === "VOICE";
  });
  var monetary = balances.find(function (balance) {
    return balance.balanceLegacyId === "MainBalance";
  });
  var gifted = balances.filter(function (balance) {
    return isGift(balance);
  });
  var dataBreakdown = balances.filter(function (balance) {
    return !balanceItemIsTotal(balance) && isData(balance);
  });
  var voiceBreakdown = balances.filter(function (balance) {
    return !balanceItemIsTotal(balance) && balance.units === "MINS";
  });
  var textBreakdown = balances.filter(function (balance) {
    return !balanceItemIsTotal(balance) && balance.units === "TEXT";
  });

  // if (data) {
  //   const units = data.units.toLocaleUpperCase()

  //   results.data = {
  //     unit: 'B',
  //     quantity: xbytes.parseSize(data.quantity + units, { iec: false }),
  //     startingQuantity: xbytes.parseSize(data.startingQuantity + units, { iec: false }),
  //   }
  // }

  if (data) results.data = data;
  if (text) results.text = text;
  if (voice) results.voice = voice;
  if (monetary) results.monetary = monetary;
  if (dataBreakdown) results.dataBreakdown = dataBreakdown;
  if (voiceBreakdown) results.voiceBreakdown = voiceBreakdown;
  if (textBreakdown) results.textBreakdown = textBreakdown;
  if (gifted) results.gifted = gifted;
  return results;
}
function isData(balance) {
  var dataTypes = [];
  dataTypes = balance.units === "Kb" || balance.units === "Mb" || balance.units === "Gb" || balance.units === "KB" || balance.units === "MB" || balance.units === "GB" || balance.units === "DATAKB" || balance.units === "DATAMB" || balance.units === "DATAGB";
  return dataTypes;
}
function getLatestInvoiceId(invoices) {
  var toReturn = undefined;
  for (var i = 0; i < invoices.length; i++) {
    if ((toReturn == undefined || toReturn.invoiceDate < invoices[i].invoiceDate) && invoices[i].category == 'CURRENT') {
      toReturn = invoices[i];
    }
  }
  return toReturn == undefined ? undefined : toReturn.invoiceId;
}
function useData(initalState) {
  var _React$useState = _react["default"].useState(initalState),
    _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
    state = _React$useState2[0],
    setState = _React$useState2[1];
  return [state, function (nextState) {
    return void setState(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), nextState);
    });
  }];
}
function getCategorisedAddOns() {
  var addOns = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var oneoff = addOns.filter(function (addOn) {
    var tags = addOn.product.tags;
    return tags.find(function (tag) {
      return tag.tag === "bolt-on";
    });
  });
  var recurring = addOns.filter(function (addOn) {
    var tags = addOn.product.tags;
    return tags.find(function (tag) {
      return tag.tag === "recurring";
    });
  });
  return {
    oneoff: oneoff,
    recurring: recurring
  };
}
function balanceItemIsTotal(balance) {
  return balance.tags !== undefined && balance.tags !== null && balance.tags.find(function (tag) {
    return tag.tag === "TOTAL";
  }) !== undefined;
}
function isGift(balance) {
  return balance.tags !== undefined && balance.tags !== null && balance.tags.find(function (tag) {
    return tag.tag === "GIFT_BALANCE";
  }) !== undefined;
}